<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Slack</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>Slack Benutzen?</col-label>
          <input type="checkbox" v-model="useSlack" />
        </div>
        <div class="form-group row">
          <col-label>Webhook url.</col-label>
          <div class="col-8">
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  https://hooks.slack.com/services/
                </div>
              </div>
              <input
                type="text"
                v-model="slackWebhookUrl"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary" type="submit" @click="save()">
          Speichern
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      useSlack: null,
      slackWebhookUrl: null,
      loaded: false
    };
  },
  created() {
    this.$store
      .dispatch("setting/all")
      .then(() => {
        this.useSlack = this.$store.getters["setting/key"]("slackSendErrors");
        this.slackWebhookUrl = this.$store.getters["setting/key"](
          "slackWebhookUrl"
        );
      })
      .finally(() => (this.loaded = true));
  },
  methods: {
    save() {
      this.$store
        .dispatch("setting/update", {
          slackSendErrors: this.useSlack,
          slackWebhookUrl: this.slackWebhookUrl
        })
        .then(() =>
          this.$notify({
            title: "Einstellungen gespeichert",
            type: "success"
          })
        );
    }
  }
};
</script>
<style scoped>
.input-group-prepend {
  background-color: #e9ecef;
}</style
>>
